import QRCode from 'qrcode';

// Get the base URL of your application
const getBaseUrl = () => {
    if (typeof window === 'undefined') return '';
    return window.location.hostname === 'localhost'
        ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
        : window.location.origin;
};

export const generateItemBarcodeDataURL = async (orderId, itemId, itemDetails) => {
    if (!orderId || !itemId) return null;

    const baseUrl = getBaseUrl();
    // Create a URL that includes both order and item information
    const itemUrl = `${baseUrl}/order-details/${orderId}/item/${itemId}`;

    try {
        // Generate QR code with options
        const qrDataUrl = await QRCode.toDataURL(itemUrl, {
            width: 200,
            margin: 2,
            color: {
                dark: '#000000',  // Black dots
                light: '#ffffff' // White background
            },
            errorCorrectionLevel: 'H' // Highest error correction capability
        });
        return qrDataUrl;
    } catch (error) {
        console.error("Error generating item QR code:", error);
        return null;
    }
};
